"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.MerchantDesignSampleStrategyScope = exports.ProducerDesignSampleStrategyScope = exports.DesignSampleStrategyIteration = exports.DesignSample = void 0;
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var DesignSample = /** @class */ (function () {
    function DesignSample() {
    }
    DesignSample.designSampleOnPieceModelEngravings = function (designSample, pieceModel, includeOnlySides) {
        var engravingsOnPieceModel = [];
        var engravingInsideSampleIndex = 0;
        for (var _i = 0, _a = pieceModel.editableAreas; _i < _a.length; _i++) {
            var editableArea = _a[_i];
            /* On editable areas on sides that are not included skip engraving. */
            if ((includeOnlySides.length !== 0) && !includeOnlySides.includes(editableArea.side))
                continue;
            /* By default assign an engraving */
            var editableAreaEngraving = __assign(__assign({}, designSample.pieceEngravings[engravingInsideSampleIndex]), { id: core_common_logic_1.CommonLogic.generateUUIDv4(), editableAreaId: editableArea.id });
            engravingsOnPieceModel.push(editableAreaEngraving);
            if (designSample.pieceEngravings.length - 1 === engravingInsideSampleIndex) {
                engravingInsideSampleIndex = 0;
            }
            else {
                engravingInsideSampleIndex++;
            }
        }
        return engravingsOnPieceModel;
    };
    return DesignSample;
}());
exports.DesignSample = DesignSample;
var DesignSampleStrategyIteration;
(function (DesignSampleStrategyIteration) {
    DesignSampleStrategyIteration["SEQUENTIAL"] = "SEQUENTIAL";
    /* RANDOM = "RANDOM" -- To be implemented later */
})(DesignSampleStrategyIteration = exports.DesignSampleStrategyIteration || (exports.DesignSampleStrategyIteration = {}));
var ProducerDesignSampleStrategyScope;
(function (ProducerDesignSampleStrategyScope) {
    ProducerDesignSampleStrategyScope["PIECE_MODEL"] = "PIECE_MODEL";
    /*  -- To be implemented later
      PIECE = "PIECE",
      CATALOG = "CATALOG" */
})(ProducerDesignSampleStrategyScope = exports.ProducerDesignSampleStrategyScope || (exports.ProducerDesignSampleStrategyScope = {}));
var MerchantDesignSampleStrategyScope;
(function (MerchantDesignSampleStrategyScope) {
    MerchantDesignSampleStrategyScope["PIECE"] = "PIECE";
    /* CATALOG = "CATALOG" -- To be implemented later */
})(MerchantDesignSampleStrategyScope = exports.MerchantDesignSampleStrategyScope || (exports.MerchantDesignSampleStrategyScope = {}));
